
document.addEventListener('DOMContentLoaded', function () {
    const formContent = document.querySelector('.lumina--thym-tab-custom-size-form');
    const tabButton = document.querySelector('.lumina--thym-unique-tab');
    const selectPopout = document.querySelector('.select-popout');
    const popupBtn = document.getElementById("lumina-measure-me-option");
    const popupSizepBtn = document.getElementById("lumina-size-chart-btn");


    if (formContent && tabButton && selectPopout) {
        // Initially hide the form content and popup button
        formContent.style.display = 'none';
        if (popupBtn) {
            popupBtn.style.display = 'none';
            console.log("Measure Me hidden on load");
        }

        tabButton.addEventListener('click', function () {
            const isHidden = formContent.style.display === 'none';

            if (isHidden) {
                formContent.style.display = 'grid';
                tabButton.classList.add('active');
                if (popupBtn) {
                    popupBtn.style.display = 'block';
                    console.log("Measure Me Shown (Custom Size toggled ON)");
                }
            } else {
                formContent.style.display = 'none';
                tabButton.classList.remove('active');
                if (popupBtn) {
                    popupBtn.style.display = 'none';
                    console.log("Measure Me hidden (Custom Size toggled OFF)");
                }
            }
        });

        selectPopout.addEventListener('click', function () {
            formContent.style.display = 'none';
            tabButton.classList.remove('active');
            if (popupBtn) {
                popupBtn.style.display = 'none';
                console.log("Measure Me hiddenn (Standard Size selected)");
            }
        });
    }
});
  // Tab Switcher Console
document.addEventListener("DOMContentLoaded", function () {
    const standardSizeTab = document.querySelector(".select-popout");
    const customSizeTab = document.querySelector(".lumina--thym-unique-tab");
    const productForm = document.querySelector(".product__form");
    const customSizeForm = document.querySelector(".lumina--thym-tab-custom-size-form");
    const allCustomSizeFields = customSizeForm.querySelectorAll("input");
    const requiredFields = customSizeForm.querySelectorAll("input[required]");
    const addToCartButton = document.querySelector("[data-add-to-cart]");
    const popupBtn = document.getElementById("lumina-measure-me-option");
   const popupSizepBtn = document.getElementById("lumina-size-chart-btn");
      if (popupBtn) {
          popupBtn.style.display = "none";
          console.log("Measure Me Button Hided");
      }
      if (popupSizepBtn){
        popupSizepBtn.style.display = "none";
        console.log("Size Chart Button Hided");
      }
    let activeTab = "";

    function logActiveTab(newTab) {
    const popupBtn = document.getElementById("lumina-measure-me-option");

    if (activeTab !== newTab) {
        console.clear();
        console.log("Active Tab:", newTab);
        activeTab = newTab;

        if (newTab === "Custom Size") {
            enableValidation();
            showInitialErrors();
            if (popupBtn) {
                popupBtn.style.display = "block";
                console.log("Measure Me Loaded (Custom Size tab)");
            }
           if (popupSizepBtn) {
                popupSizepBtn.style.display = "none";
                console.log("Size Guide Hided (Standard Size tab)");
            }
        } else {
            disableValidation();
            clearCustomSizeFields();
            if (popupBtn) {
                popupBtn.style.display = "none";
                console.log("Measure Me Hided (Standard Size tab)");
            }
           if (popupSizepBtn) {
                popupSizepBtn.style.display = "block";
                console.log("Size Guide Loaded (Standard Size tab)");
            }

        }
    }
}


  
    function enableValidation() {
        console.log("Enabling validation for Custom Size tab");
        addToCartButton.disabled = true;
        addToCartButton.classList.add("disabled");
    }

    function disableValidation() {
        // console.log("Disabling validation for Custom Size tab");
        addToCartButton.disabled = false;
        addToCartButton.classList.remove("disabled");
        requiredFields.forEach(input => {
            input.classList.remove("error");
            const errorMessage = input.parentNode.querySelector(".error-message");
            if (errorMessage) {
                errorMessage.remove();
            }
        });
    }

    function showInitialErrors() {
        requiredFields.forEach(input => {
            if (!input.nextElementSibling || !input.nextElementSibling.classList.contains("error-message")) {
                const errorMessage = document.createElement("span");
                errorMessage.classList.add("error-message");
                errorMessage.textContent = "This field is required";
                input.parentNode.appendChild(errorMessage);
            }
        });
    }

    function validateForm() {
        let isValid = true;
        requiredFields.forEach(input => {
            const errorMessage = input.parentNode.querySelector(".error-message");
            if (!input.value.trim()) {
                isValid = false;
                input.classList.add("error");
                if (errorMessage) {
                    errorMessage.style.display = "block";
                }
            } else {
                input.classList.remove("error");
                if (errorMessage) {
                    errorMessage.style.display = "none";
                }
            }
        });
        
        addToCartButton.disabled = !isValid;
        addToCartButton.classList.toggle("disabled", !isValid);
    }

    function clearCustomSizeFields() {
        // console.log("Clearing all custom size input fields");
        allCustomSizeFields.forEach(input => {
            input.value = "";
        });
    }

    requiredFields.forEach(input => {
        input.addEventListener("input", validateForm);
    });

    // Track clicks on standard size tab
    standardSizeTab.addEventListener("click", function (event) {
        event.stopPropagation();
        logActiveTab("Standard Size");
    });

    // Track clicks on custom size tab
    customSizeTab.addEventListener("click", function (event) {
        event.stopPropagation();
        logActiveTab("Custom Size");
    });
});

// ---------- For translation
document.addEventListener("DOMContentLoaded", () => {
    if (window.location.pathname.includes('/ar')) {
        const translations = {
            "custom size": "مقاس مخصص",
            "waist": "خصر",
            "underbust": "تحت الصدر",
            "bust": "محيط الصدر",
            "small hip": "ورك صغير",
            "length bust Y": "طول محيط الصدر Y",
            "length bust X": "طول محيط الصدر X",
            "wrist": "معصم",
            "arm": "ذراع",
            "large hip": "ورك كبير",
            "skirt length": "طول التنورة",
            "sleeve length": "طول الكم",
            "shoulders width": "عرض الأكتاف",
            "size in cm": "المقاس بالسنتيمتر"
        };

        document.querySelectorAll(".lumina--thym-tab-custom-size-form label").forEach(label => {
            Object.keys(translations).sort((a, b) => b.length - a.length).forEach(engText => {
                const regex = new RegExp(`\\b${engText}\\b`, "gi");
                label.innerHTML = label.innerHTML.replace(regex, translations[engText]);
            });
        });

        const customSizeDiv = document.querySelector(".lumina--thym--custom-size-section .lumina--thym-unique-tab");
        if (customSizeDiv) customSizeDiv.textContent = translations["custom size"];

        document.querySelectorAll(".lumina--thym-tab-custom-size-form input").forEach(input => {
            if (input.placeholder.toLowerCase() === "size in cm") {
                input.placeholder = translations["size in cm"];
            }
        });

        document.querySelectorAll(".lumina--thym-tab-custom-size-form .error-message").forEach(errorMsg => {
            if (errorMsg.innerHTML.trim().toLowerCase() === "this field is required") {
                errorMsg.innerHTML = "هذا الحقل مطلوب";
            }
        });
    }
});